import { useState, useEffect } from "react";
import { loadBankAccountType } from "../services/bankDetailService";

const useBankAccountType = (editID) => {

    const [bankAccounts, setBankAccounts] = useState([]);
    const [selectedBankAccounts, setSelectedBankAccounts] = useState(null);
    const [selectedBankAccountID, setSelectedBankAccountID] = useState(null);
    const [isBankAccountDataLoaded, setIsBankAccountDataLoaded] = useState(false);

    // Fetch department data
    const fetchBankAccountList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid:1 };

        try {
            const data = await loadBankAccountType(para);
            if (data && data.length > 0) {
                setBankAccounts(data);
                const initialDepartment = data.find((dept) => dept.id === selectedID);

                if (initialDepartment) { // ✅ Corrected check
                    setSelectedBankAccounts(initialDepartment);
                    setSelectedBankAccountID(initialDepartment.id);
                    setIsBankAccountDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isBankAccountDataLoaded && editID === 0) {
            fetchBankAccountList();
        }
    }, [isBankAccountDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadBankAccountByID = async (selectedID) => {
        await fetchBankAccountList(selectedID);
    };

    return {
         bankAccounts,
         selectedBankAccounts,
         selectedBankAccountID,
         setSelectedBankAccounts,
         setSelectedBankAccountID,
         loadBankAccountByID,
    };
};

export default useBankAccountType;
